import { styled as t } from "styled-components";
import { ZIndex as n } from "../../styles/variables.js";
const r = t.button`
  background: none;
`, a = t.div`
  display: flex;
  width: max-content;
  height: max-content;
  position: relative;
`, s = t.div`
  position: absolute;
  z-index: ${n.POPOVER};

  width: fit-content;
  height: fit-content;

  bottom: 100%;
  right: 50%;
  transform: translateX(50%);

  ${({ $extendesStyle: o }) => o || ""}
`;
export {
  r as Button,
  a as Container,
  s as PopoverContainer
};
